import React from "react";
import LegalLayout, { Section } from "@/pages/LegalLayout";
import { useLanguage } from "@/context/LanguageContext";

const Terms = () => {
  const { lang } = useLanguage();
  return (
    <LegalLayout
      testId="terms-page"
      eyebrow={lang === "ta" ? "சட்டம்" : "Legal"}
      title={
        lang === "ta"
          ? "விதிமுறைகள் & நிபந்தனைகள்"
          : "Terms & Conditions"
      }
    >
      <p>
        {lang === "ta"
          ? "TNPSC தமிழ் செயலியை ('செயலி', 'சேவை') பயன்படுத்துவதற்கு முன், இந்த விதிமுறைகள் & நிபந்தனைகளை கவனமாக படிக்கவும். செயலியை அணுகுவதன் மூலம், கீழே குறிப்பிட்டுள்ள விதிமுறைகளுக்கு நீங்கள் ஒப்புக்கொள்கிறீர்கள்."
          : "Please read these Terms & Conditions carefully before using the TNPSC Tamil mobile application ('app', 'service'). By accessing or using our app, you agree to be bound by the terms set out below."}
      </p>

      <Section title={lang === "ta" ? "1. சேவையின் பயன்பாடு" : "1. Use of the service"}>
        <p>
          {lang === "ta"
            ? "Vetri Guide என்பது TNPSC Group 4, Group 2/2A மற்றும் TNUSRB தேர்வுகளுக்கான ஒரு கல்வி தயாரிப்பு செயலி. நீங்கள் தனிப்பட்ட, வணிகம் அல்லாத கல்வி நோக்கங்களுக்காக மட்டுமே இந்த செயலியை பயன்படுத்த ஒப்புக்கொள்கிறீர்கள்."
            : "Vetri Guide is an educational preparation app for TNPSC Group 4, Group 2/2A and TNUSRB exams. You agree to use the app solely for personal, non-commercial educational purposes."}
        </p>
        <p>
          {lang === "ta"
            ? "சேவையின் தவறான பயன்பாடு, மீட்டெடுக்கும் தாக்குதல்கள் (scraping), தானியங்கி கருவிகள், அல்லது உள்ளடக்கத்தை விநியோகித்தல் கண்டிப்பாக தடைசெய்யப்பட்டுள்ளது."
            : "Misuse of the service — including scraping, automated tools, reverse engineering, or redistributing content — is strictly prohibited."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "2. பயனர் கணக்கு" : "2. Your account"}>
        <p>
          {lang === "ta"
            ? "சேவையின் சில அம்சங்களைப் பயன்படுத்த நீங்கள் ஒரு கணக்கை உருவாக்க வேண்டும். உங்கள் கணக்கின் கடவுச்சொல்லைப் பாதுகாப்பது மற்றும் கணக்கின் கீழ் நடைபெறும் அனைத்து செயல்பாடுகளுக்கும் நீங்களே பொறுப்பாவீர்கள்."
            : "You must create an account to access certain features. You are responsible for safeguarding your password and for all activity that occurs under your account."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "3. சந்தாக்கள் & கட்டணம்" : "3. Subscriptions & billing"}>
        <p>
          {lang === "ta"
            ? "செலுத்திய சந்தாக்கள் மீள் கட்டண காலத்தில் (மாதம்) தானாக புதுப்பிக்கப்படும். எப்போது வேண்டுமானாலும் செயலியில் இருந்து ரத்து செய்யலாம்."
            : "Paid subscriptions auto-renew at the end of each billing period (monthly). You can cancel anytime from within the app."}
        </p>
        <p>
          {lang === "ta"
            ? "7-நாள் இலவச முயற்சி காலத்திற்குள் ரத்து செய்தால், எந்த கட்டணமும் வசூலிக்கப்படாது."
            : "If you cancel within the 7-day free trial period, you will not be charged."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "4. அறிவுசார் சொத்து" : "4. Intellectual property"}>
        <p>
          {lang === "ta"
            ? "செயலியில் உள்ள அனைத்து உள்ளடக்கமும் — வினாக்கள், விளக்கங்கள், வடிவமைப்பு, லோகோக்கள் — TNPSC தமிழின் சொத்து அல்லது அதன் உரிமம் பெற்றவர்களின் சொத்து. முன் எழுத்துப்பூர்வ அனுமதி இல்லாமல் இவற்றை நகலெடுக்கவோ, மறுபதிப்பிக்கவோ முடியாது."
            : "All content within the app — questions, explanations, design, logos — is the property of TNPSC Tamil or its licensors. You may not copy, reproduce, or republish any content without prior written permission."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "5. தடை & நிறுத்தம்" : "5. Termination"}>
        <p>
          {lang === "ta"
            ? "இந்த விதிமுறைகளை மீறும் கணக்குகளை எங்களின் சொந்த விருப்பத்தின்படி எச்சரிக்கையின்றி நிறுத்தும் அல்லது இடைநிறுத்தும் உரிமை எங்களுக்கு உள்ளது."
            : "We reserve the right to suspend or terminate accounts that violate these terms, at our sole discretion and without notice."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "6. பொறுப்பு வரம்பு" : "6. Limitation of liability"}>
        <p>
          {lang === "ta"
            ? "செயலி 'அப்படியே' வழங்கப்படுகிறது. தேர்வில் வெற்றி குறித்த எந்த உத்தரவாதமும் இல்லை. சேவையின் பயன்பாட்டால் ஏற்படும் மறைமுக சேதங்களுக்கு நாங்கள் பொறுப்பாக மாட்டோம்."
            : "The app is provided 'as is'. We make no warranty of guaranteed exam success. We are not liable for any indirect damages arising from your use of the service."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "7. ஆளுகை சட்டம்" : "7. Governing law"}>
        <p>
          {lang === "ta"
            ? "இந்த விதிமுறைகள் இந்திய சட்டத்தின்படி ஆளப்படும். அனைத்து சர்ச்சைகளுக்கும் தமிழ்நாடு, சென்னையின் நீதிமன்றங்களே அதிகார வரம்பு பெற்றவை."
            : "These terms are governed by the laws of India. All disputes are subject to the exclusive jurisdiction of the courts of Chennai, Tamil Nadu."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "8. தொடர்பு" : "8. Contact"}>
        <p>
          {lang === "ta"
            ? "கேள்விகள் இருந்தால் "
            : "If you have questions, contact us at "}
          <a
            href="mailto:tnpsctamilapp@gmail.com"
            className="text-blue-900 font-semibold underline decoration-amber-400 underline-offset-4"
          >
            tnpsctamilapp@gmail.com
          </a>{" "}
          {lang === "ta" ? "என்ற முகவரியில் தொடர்பு கொள்ளுங்கள்." : "."}
        </p>
      </Section>
    </LegalLayout>
  );
};

export default Terms;
